// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3I0JG"};